module.exports = __webpack_public_path__ + "static/media/appShadow.88d5d4f1.svg";